import React, { useEffect, useState } from 'react';
import { Router } from 'react-router-dom';
import { RootProvider } from '../../context';
import { Routes } from '../../routes';
import history from '../../history';
import { VideoBase } from '../VideoBase';
import { initModel, sendMessageToParent } from '../../utils';
import { Cross } from '../Cross';
import { EnfaceAuthWidget } from '../../../core';

export const AppIndex = () => {
  // console.log('[Index].render');
  const [video, setVideo] = useState(null);
  const [videoParams, setVideoParams] = useState(null);
  const [ctx, setCtx] = useState(null);
  const [tfBackend, setTfBackend] = useState(null);
  const [model, setModel] = useState();
  const [normalEntrance, setNormalEntrance] = useState(false);
  const [captureVideo, setCaptureVideo] = useState(false);
  const [qrSrc, setQrSrc] = useState(null);
  const setupModel = async () => {
    // console.log('[Index].render setupModel');
    const [initiated, backend] = await initModel();
    // console.warn('tf.backend', backend);
    setTfBackend(backend);
    setModel(initiated);
  };
  useEffect(() => {
    setupModel();
  }, []);
  useEffect(() => {
    const projectId = localStorage.getItem('projectId');
    const backendURL = localStorage.getItem('backendURL');
    new EnfaceAuthWidget({
      debug: true,
      projectId,
      backendURL,
      setQrSrc,
      onSuccess: data => {
        // console.log('[EnfaceAuthWidget].external.onSuccess', { data });
        sendMessageToParent({ _: 'success', token: data });
      },
    });
  }, []);

  return (
    <>
      <RootProvider value={{
        video,
        setVideo,
        videoParams,
        setVideoParams,
        setCaptureVideo,
        captureVideo,
        ctx,
        setCtx,
        model,
        qrSrc,
        normalEntrance,
        setNormalEntrance,
        tfBackend,
      }}>
        <Router history={history} >
          <div className="widget-root">
            <Cross />
            <div className="widget-container">
              <Routes />
            </div>
          </div>
        </Router>
        <VideoBase />
      </RootProvider>
    </>
  );
};
